export default __webpack_public_path__ + "static/media/Marathi_am_1.00536fd1.mp3";